import * as React from 'react';
import {Routing} from '@mintdata-wsp/wsp/ui/routes/Routing';
import {Href} from '@mintdata-wsp/wsp/ui/components/text/Href';

export class LinkUtil
{
    public static make(path:string, caption:string, className:string)
    {
        let paths  = Routing.paths() as any;
        let pathFn = paths[path];

        if( !pathFn )
            throw new Error(`Cannot find path: '${path}'`);

        const _path = pathFn();
        return <Href to={_path} className={className}>{caption}</Href>;
    }
}